export default "__VITE_ASSET__4d37bfbc__"